/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * exemONE target Api
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseTargetCountByCategoryResponse,
  ApiResponseTargetKindSubKindResponse,
  ApiResponseTargetStatusResponse,
  TargetStatusRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary target 상태
 */
export const postV11Target = (
  targetStatusRequest: MaybeRef<TargetStatusRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  targetStatusRequest = unref(targetStatusRequest);

  return customAxiosInstance<ApiResponseTargetStatusResponse>(
    {
      url: `/api/v11/target/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: targetStatusRequest,
      signal,
    },
    options,
  );
};

export const getPostV11TargetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV11Target>>,
    TError,
    { data: BodyType<TargetStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV11Target>>,
  TError,
  { data: BodyType<TargetStatusRequest> },
  TContext
> => {
  const mutationKey = ['postV11Target'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV11Target>>,
    { data: BodyType<TargetStatusRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV11Target(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV11TargetMutationResult = NonNullable<Awaited<ReturnType<typeof postV11Target>>>;
export type PostV11TargetMutationBody = BodyType<TargetStatusRequest>;
export type PostV11TargetMutationError = ErrorType<unknown>;

/**
 * @summary target 상태
 */
export const usePostV11Target = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV11Target>>,
      TError,
      { data: BodyType<TargetStatusRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV11Target>>,
  TError,
  { data: BodyType<TargetStatusRequest> },
  TContext
> => {
  const mutationOptions = getPostV11TargetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 각 도메인 카테고리에 설정된 대상 수를 반환하는 API
 */
export const getV11TargetByCategoryCount = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseTargetCountByCategoryResponse>(
    { url: `/api/v11/target/by-category/count`, method: 'GET', signal },
    options,
  );
};

export const getGetV11TargetByCategoryCountQueryKey = () => {
  return ['api', 'v11', 'target', 'by-category', 'count'] as const;
};

export const getGetV11TargetByCategoryCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11TargetByCategoryCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV11TargetByCategoryCount>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11TargetByCategoryCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11TargetByCategoryCount>>> = ({
    signal,
  }) => getV11TargetByCategoryCount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11TargetByCategoryCount>>,
    TError,
    TData
  >;
};

export type GetV11TargetByCategoryCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11TargetByCategoryCount>>
>;
export type GetV11TargetByCategoryCountQueryError = ErrorType<unknown>;

/**
 * @summary 각 도메인 카테고리에 설정된 대상 수를 반환하는 API
 */

export function useGetV11TargetByCategoryCount<
  TData = Awaited<ReturnType<typeof getV11TargetByCategoryCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11TargetByCategoryCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11TargetByCategoryCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 등록된 target kind, sub kind
 */
export const postV11TargetKind = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseTargetKindSubKindResponse>(
    { url: `/api/v11/target/kind`, method: 'POST', signal },
    options,
  );
};

export const getPostV11TargetKindMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV11TargetKind>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postV11TargetKind>>, TError, void, TContext> => {
  const mutationKey = ['postV11TargetKind'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV11TargetKind>>, void> = () => {
    return postV11TargetKind(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV11TargetKindMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV11TargetKind>>
>;

export type PostV11TargetKindMutationError = ErrorType<unknown>;

/**
 * @summary 등록된 target kind, sub kind
 */
export const usePostV11TargetKind = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV11TargetKind>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<Awaited<ReturnType<typeof postV11TargetKind>>, TError, void, TContext> => {
  const mutationOptions = getPostV11TargetKindMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
